import React, { Component } from 'react';
import moduleCss from "./index.module.scss";
import { postData } from '../../utils/utils';
import GPS from '../../utils/gps'
const wx = window.wx;

class Bus extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.getWxConfig()

  }
  getWxConfig = async () => {
    await postData('/api/applite/gs/', { url: window.location.href.split('#')[0] })
      .then((res) => {
        const data = res.data;
        wx.config({
          appId: 'wx6e497c0af99108e5',
          timestamp: Number(data.timestamp),
          nonceStr: data.noncestr,
          signature: data.signature,
          jsApiList: ['openLocation'],
        });
      })
      .catch((res) => { });
  }
  goNav() {
    const coord = GPS.gcj_encrypt(34.23527598, 108.98524404)
    console.log(coord)
    wx.openLocation({
      latitude: 34.235018,// 纬度，浮点数，范围为90 ~ -90
      longitude: 108.989233,  //北门停车场
      name: '西安市青龙寺遗址景区', // 位置名
      address: '', // 地址详情说明
      scale: 17, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
  }
  render() {
    return (
      <div className={moduleCss.ctnr}>
        <img className={moduleCss.banner} src={require('../../assets/bus/pic_sc.png')} alt="" />
        <div className={moduleCss.item}>
          <i className={moduleCss.icon_gj}></i>
          <div>
            <h1 className={moduleCss.title}>公交</h1>
            <p className={moduleCss.desc}>乘坐19、25、41、45、48、118、221、237、242、400、521、525、526、606、607、游6路公交在“青龙寺”或‘铁炉庙”站下站，按路牌指引顺大路西侧村落中一条登高小路走上去即可到达。</p>
          </div>
        </div>
        <div className={moduleCss.item}>
          <i className={moduleCss.icon_dt}></i>
          <div>
            <h1 className={moduleCss.title}>地铁</h1>
            <p className={moduleCss.desc}>乘坐西安地铁3号线在“青龙寺”地铁站A出口，或西安地铁5号线在“青龙寺”地铁站G出口，沿雁翔路向北300米即到青龙寺东门。</p>
          </div>
        </div>
        <div className={moduleCss.item}>
          <i className={moduleCss.icon_dt}></i>
          <div>
            <h1 className={moduleCss.title}>驾车</h1>
            <p className={moduleCss.desc}>驾车跟着导航走，保你最快到达。</p>
          </div>
        </div>
        <button className={moduleCss.btn_nav} onClick={() => {
          this.goNav()
        }}>导航前往</button>
      </div>
    )
  }
}
export default Bus